// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f2b928d6","311":"b6dc14b0","732":"2bcfba2c","977":"9cf28889"}[chunkId] + ".chunk.js";
};